
<div class="sub-header" :type="type" :transform="transform">
	<slot />
</div>
